import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconBarsTwo: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-1.5-IconBarsTwo"><Path fillRule="evenodd" clipRule="evenodd" d="M2 6.5H22V8H2V6.5ZM2 16H22V17.5H2V16Z" fill="currentColor"/></CentralIconBase>;
});

export default IconBarsTwo;
